import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoaderError } from '../../../model';
import { PyStateUtils } from '../../../state/utils';
import { ArticlePriceState, StateWithUser, UserState } from '../user-state';
import { getUserState } from './feature.selector';

export const getPricesState: MemoizedSelector<StateWithUser, StateUtils.EntityLoaderState<ArticlePriceState>> = createSelector(
  getUserState,
  (state: UserState) => state && state.prices
);

export const getArticlePriceState: MemoizedSelectorWithProps<
  StateWithUser,
  any,
  StateUtils.LoaderState<ArticlePriceState>
> = createSelector(getPricesState, (state: StateUtils.EntityLoaderState<ArticlePriceState>, props) =>
  PyStateUtils.entityLoaderStateSelector(state, props.key)
);

export const getArticlePriceStateValue: MemoizedSelectorWithProps<StateWithUser, any, ArticlePriceState | undefined> =
  createSelector(
    getPricesState,
    (state: StateUtils.EntityLoaderState<ArticlePriceState>, props) =>
      (!StateUtils.entityLoadingSelector(state, props.key) && StateUtils.entityValueSelector(state, props.key)) || undefined
  );

export const getArticlePriceStateLoading: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getPricesState,
  (state: StateUtils.EntityLoaderState<ArticlePriceState>, props) => StateUtils.entityLoadingSelector(state, props.key)
);

export const getArticlePriceStateSuccess: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getPricesState,
  (state: StateUtils.EntityLoaderState<ArticlePriceState>, props) => StateUtils.entitySuccessSelector(state, props.key)
);

export const getArticlePriceLoadingAttempts: MemoizedSelectorWithProps<StateWithUser, any, number | undefined> = createSelector(
  getArticlePriceStateValue,
  (state: ArticlePriceState | undefined) => state?.attempts
);

export const getArticlePriceStateError: MemoizedSelectorWithProps<StateWithUser, any, LoaderError | undefined> = createSelector(
  getPricesState,
  (state: StateUtils.EntityLoaderState<ArticlePriceState>, props) => PyStateUtils.entityErrorDetailsSelector(state, props.key)
);
